import { render, staticRenderFns } from "./BuyButton.vue?vue&type=template&id=a9c25e84&scoped=true"
import script from "./BuyButton.vue?vue&type=script&lang=js"
export * from "./BuyButton.vue?vue&type=script&lang=js"
import style0 from "./BuyButton.vue?vue&type=style&index=0&id=a9c25e84&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9c25e84",
  null
  
)

export default component.exports